const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/**
 * Formats a byte count into a human-readable string using binary (1024) units,
 * e.g. `formatBytes(524288000)` → `'500 MB'`. Values are rounded to at most one
 * decimal place; whole numbers are shown without a trailing `.0`.
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return '0 B';
  }
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1,
  );
  const value = bytes / Math.pow(1024, exponent);
  const rounded = Math.round(value * 10) / 10;
  return `${rounded} ${UNITS[exponent]}`;
}
